const state = {
  RUBLE_SYMBOL: "₽",
  PRICE_VALUE_TYPE_1: "₽",
  PRICE_VALUE_TYPE_2: "%",
};

export default {
  state,
};
